module.exports = __webpack_public_path__ + "static/media/Artboard11.c45559de.png";